module.exports = __webpack_public_path__ + "static/media/white_panel.2da4831b.png";